import { Component, Input } from "@angular/core"

import { MerchantReferralCampaignPagesColors } from "../../shared/merchant-referral"

@Component({
  selector: "app-referrals-table",
  templateUrl: "./referrals-table.component.html",
  styleUrls: ["./referrals-table.component.scss"]
})
export class ReferralMagicReferralsTableComponent {
  @Input() referrals: any
  @Input() colors: MerchantReferralCampaignPagesColors

  constructor() {}
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/referrals-table/referrals-table.component.ts